import React from 'react';
import './CircularGauge.css';

const CircularGauge = ({
  value,
  max = 100,
  min = 0,
  label,
  unit,
  color = '#66B4C4',
  size = 120,
  thickness = 8,
  icon
}) => {
  const percentage = ((value - min) / (max - min)) * 100;
  const circumference = 2 * Math.PI * (size / 2 - thickness);
  const strokeDashoffset = circumference - (percentage / 100) * circumference;

  // Dynamic color based on percentage
  const getColor = () => {
    if (percentage < 20) return '#ef4444'; // Red
    if (percentage < 50) return '#f59e0b'; // Amber
    if (percentage < 80) return '#66B4C4';
    return '#10b981'; // Green
  };

  const gaugeColor = color === 'auto' ? getColor() : color;

  return (
    <div className="circular-gauge" style={{ width: size, height: size }}>
      <svg
        className="gauge-svg"
        width={size}
        height={size}
        viewBox={`0 0 ${size} ${size}`}
      >
        {/* Background Circle */}
        <circle
          className="gauge-bg"
          cx={size / 2}
          cy={size / 2}
          r={size / 2 - thickness}
          fill="none"
          stroke="rgba(102, 180, 196, 0.1)"
          strokeWidth={thickness}
        />

        {/* Progress Circle */}
        <circle
          className="gauge-progress"
          cx={size / 2}
          cy={size / 2}
          r={size / 2 - thickness}
          fill="none"
          stroke={gaugeColor}
          strokeWidth={thickness}
          strokeLinecap="round"
          strokeDasharray={circumference}
          strokeDashoffset={strokeDashoffset}
          transform={`rotate(-90 ${size / 2} ${size / 2})`}
          style={{
            transition: 'stroke-dashoffset 1s ease-in-out, stroke 0.3s ease'
          }}
        />

        {/* Glow Effect */}
        <circle
          cx={size / 2}
          cy={size / 2}
          r={size / 2 - thickness}
          fill="none"
          stroke={gaugeColor}
          strokeWidth={thickness * 0.5}
          opacity="0.3"
          strokeDasharray={circumference}
          strokeDashoffset={strokeDashoffset}
          transform={`rotate(-90 ${size / 2} ${size / 2})`}
          style={{
            filter: `blur(4px)`,
            transition: 'stroke-dashoffset 1s ease-in-out'
          }}
        />
      </svg>

      <div className="gauge-content">
        {icon && <div className="gauge-icon">{icon}</div>}
        <div className="gauge-value" style={{ color: gaugeColor }}>
          {typeof value === 'number' ? value.toFixed(1) : value}
          {unit && <span className="gauge-unit">{unit}</span>}
        </div>
        {label && <div className="gauge-label">{label}</div>}
      </div>
    </div>
  );
};

export default CircularGauge;
